import React, { useState } from 'react';
import { useLocation } from 'react-router';
import links from '../data/site-structure';
import { dubifyUrl } from '../header-utils';
import { StyledPrimaryNav, StyledNavItem, StyledNavLink } from './primary-navigation.styled';
var baseClassName = 'atds-primary-navigation';
var getMenuItemTrackingLabel = function (item) {
    var text = item.displayText.split(' ');
    text.unshift('nav');
    return text.join('-').toLowerCase();
};
export var PrimaryNavigation = function (_a) {
    var _b;
    var channel = _a.channel, _c = _a.show, show = _c === void 0 ? true : _c, _d = _a.className, className = _d === void 0 ? '' : _d, env = _a.env, trackingCallbacks = _a.trackingCallbacks;
    var _e = useState(''), previousKey = _e[0], setPreviousKey = _e[1];
    var currentPathname = (_b = useLocation().pathname) !== null && _b !== void 0 ? _b : '';
    var siteData = links;
    var channelData = siteData[channel];
    var primaryNavLinks = channelData.header.primaryNav;
    var handleLastLinkTabbed = function (e) {
        var menuBtn = document.querySelector('.atds-menu-btn');
        if (e.key === 'Tab' && previousKey !== 'Shift' && menuBtn.offsetWidth > 0) {
            menuBtn.focus();
            e.preventDefault();
        }
    };
    if (!show)
        return null;
    return (React.createElement(StyledPrimaryNav, { as: "ul", id: "menu-nav", role: "menubar", className: className }, primaryNavLinks &&
        typeof primaryNavLinks == 'object' &&
        Object.values(primaryNavLinks).map(function (item, key) {
            var isLastItem = key === primaryNavLinks.length - 1;
            var isSelected = currentPathname.indexOf(item.url) === 0;
            var environment = env || 'prod';
            var url = dubifyUrl(item.url, channel, environment);
            var trackingLabel = getMenuItemTrackingLabel(item);
            return (React.createElement(StyledNavItem, { selected: isSelected, key: key, role: "menuitem" },
                React.createElement(StyledNavLink, { "aria-current": isSelected, selected: isSelected, href: url, className: "".concat(baseClassName, "__link"), onClick: function () {
                        return trackingCallbacks === null || trackingCallbacks === void 0 ? void 0 : trackingCallbacks.onNavigationClick({
                            labelIdentifier: trackingLabel,
                        });
                    }, onKeyDown: function (e) {
                        return isLastItem
                            ? handleLastLinkTabbed(e)
                            : setPreviousKey(e.key);
                    } }, item.displayText)));
        })));
};
